import { useState, useEffect } from "react";
import { Card, CardContent } from "../ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { AnnualBreakdownTable } from "./AnnualBreakdownTable";
import { AnnualEvolutionChart } from "./AnnualEvolutionChart";
import { api } from "../../lib/api";

export function AnnualBreakdownTab({ token, balances }) {
  const [selected, setSelected] = useState(balances[0]?.project_name || "");
  const [records, setRecords] = useState(null);
  const projectTotal = balances.find((b) => b.project_name === selected);

  useEffect(() => {
    if (!selected) return;
    api.getRdAnnualBreakdown(token, selected).then((d) => setRecords(d.records)).catch(() => setRecords(null));
  }, [token, selected]);

  return (
    <Card data-testid="annual-breakdown-tab">
      <CardContent className="pt-6">
        <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
          <div>
            <h3 className="font-semibold">Vista Proyecto-Año</h3>
            <p className="text-xs text-muted-foreground">Desglose anual (2012-2028) leído directamente de las columnas anuales del libro fuente, celda a celda.</p>
          </div>
          <Select value={selected} onValueChange={setSelected}>
            <SelectTrigger className="w-[260px]" data-testid="annual-project-selector">
              <SelectValue placeholder="Selecciona un proyecto" />
            </SelectTrigger>
            <SelectContent>
              {balances.map((b) => (
                <SelectItem key={b.id} value={b.project_name}>{b.project_name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        {selected && (
          <>
            <p className="text-xs font-medium text-muted-foreground mb-2">Evolución: Presupuesto vs Gasto Real</p>
            <AnnualEvolutionChart records={records} />
            <div className="mt-6">
              <AnnualBreakdownTable token={token} projectName={selected} projectTotal={projectTotal} />
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
